var _defs, _polygon, _polygon2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallEmLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "99.71 89.23 210.96 88.22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#143641;}"))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "211.94 89.23 227.07 89.23 261.41 156.96 262.09 156.96 295.77 89.23 310.67 89.23 310.67 177.45 295.77 177.45 295.77 105.18 295.26 105.18 259.11 177.45 256.05 177.45 219.47 105.7 218.43 105.7 218.43 177.45 211.94 177.45 211.94 89.23",
    fill: "#143641"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "161.04 89.23 161.04 94.89 114.55 94.89 114.55 126.48 145.61 126.48 145.61 132.15 114.55 132.15 114.55 171.79 161.04 171.79 161.04 177.45 99.71 177.45 99.71 89.23 161.04 89.23",
    fill: "#143641"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallEmLogo);
export default __webpack_public_path__ + "static/media/smallEmLogo.8f0b79d60d555c5a6496286f032b2ae3.svg";
export { ForwardRef as ReactComponent };